import { useNavigate, useLocation } from "react-router-dom";

const ProjectDetailsCard = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const project = location.state || {};
    return (
        <div className="project-details-card">
            <div className="project-details-card-images">
                <img src={project.image1} draggable={false} alt="image-large" className="image-large" />
                <img src={project.image2} draggable={false} alt="image-small" className="image-small" />
            </div>

            <div className="project-details-card-details">
                <h2 className="project-details-card-title">{project.projectName.toUpperCase()}</h2>
                <p className="project-details-card-description">{project.description}</p>

                <div className="project-details-card-project-info">
                    <div className="project-details-card-info-column">
                        <div className="project-details-card-info-label">Budget</div>
                        <div className="project-details-card-info-value">{project.budget}</div>
                    </div>

                    <div className="project-details-card-info-column">
                        <div className="project-details-card-info-label">Size</div>
                        <div className="project-details-card-info-value">{project.size} Sq.Ft.</div>
                    </div>

                    <div className="project-details-card-info-column">
                        <div className="project-details-card-info-label">Type</div>
                        <div className="project-details-card-info-value">{project.type}</div>
                    </div>

                    <div className="project-details-card-info-column">
                        <div className="project-details-card-info-label">Status</div>
                        <div className="project-details-card-info-value">{project.status}</div>
                    </div>

                    <div className="project-details-card-info-column">
                        <div className="project-details-card-info-label">Location</div>
                        <div className="project-details-card-info-value">{project.location}</div>
                    </div>

                    <div className="project-details-card-info-column">
                        <div className="project-details-card-info-label">Flat</div>
                        <div className="project-details-card-info-value">{project.flat}</div>
                    </div>
                </div>

                <div className="project-details-card-services-used">
                    <div className="project-details-card-info-label">Services Used</div>
                    <ul className="project-details-card-services-list">
                        {project.services?.map((service: string, index: number) => (
                            <li key={index} className="project-details-card-service-item">
                                {service}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="project-details-card-button-wrapper" >
                    <button className="project-details-card-book-button" onClick={() => {
                        navigate('/Contacts');
                        setTimeout(() => {
                            const contactForm = document.querySelector('.contactFormContainer');
                            if (contactForm) {
                                contactForm.scrollIntoView({ behavior: "smooth" });
                            } else {
                                window.scrollTo({ top: 0 })
                            }
                        }, 100);
                    }}>
                        CONTACT NOW </button>
                    <svg width="210" height="78" viewBox="0 0 210 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M207.519 0.0167386C203.203 0.170716 197.413 1.37029 192.831 3.06003C182.37 6.91725 173.378 14.3215 168.023 23.4881C165.259 28.2181 164.057 31.7202 161.003 43.9265C159.961 48.095 159.03 50.626 157.254 54.1193C156.047 56.4959 155.294 57.7839 154.465 58.8922C150.148 64.6609 144.26 69.2255 137.334 72.1728C134.566 73.3506 128.768 74.9684 126.01 75.3321C118.195 76.3632 110.722 75.548 102.793 72.7995C100.332 71.9465 94.6304 69.1977 92.3143 67.7479C87.4633 64.7111 82.9834 60.941 79.4811 56.9481C78.6521 56.0031 77.9597 55.1967 77.9423 55.1561C77.925 55.1157 78.3686 54.837 78.9284 54.5371C83.5614 52.0543 87.3403 48.0292 88.783 44.0404C89.5955 41.7944 89.7758 40.6861 89.7269 38.2397C89.6937 36.5814 89.5543 35.6845 89.1393 34.46C88.5041 32.5855 87.2906 30.6401 85.8836 29.2404C84.6683 28.0315 82.4368 26.6967 80.9791 26.3066C76.7377 25.1714 72.36 26.9502 69.8003 30.8487C66.2839 36.2043 67.3814 43.309 73.0495 51.8825C74.7615 54.4719 74.7377 54.1605 73.2664 54.7086C67.6823 56.7893 59.7436 58.6109 52.6208 59.4459C44.4888 60.3994 35.468 60.2967 26.81 59.1525C23.3478 58.6949 15.8132 57.2091 15.6426 56.9503C15.5806 56.8561 15.6256 56.6848 15.7427 56.57C16.0953 56.2241 20.5653 49.8344 20.5891 49.6422C20.6013 49.5441 20.0124 49.7006 19.2802 49.9896C15.6599 51.4191 8.79374 52.9241 3.17699 53.5192C1.70504 53.6751 0.516269 53.8445 0.535155 53.8957C0.554282 53.9468 1.47143 54.6573 2.57323 55.4747C7.13955 58.8616 12.1272 63.4349 14.9622 66.8342C15.5569 67.5473 16.0842 68.1193 16.1342 68.1055C16.184 68.0914 16.0647 66.8935 15.8688 65.4431C15.1572 60.1702 15.0379 59.0463 15.1887 59.0395C15.2734 59.0355 16.0317 59.2014 16.8738 59.4081C19.5073 60.054 24.7645 60.9603 28.3256 61.3824C41.3786 62.9292 54.8952 62.0665 66.6332 58.9374C69.8706 58.0743 73.391 56.9786 75.1594 56.2836L75.9359 55.9784L77.539 57.8193C89.4726 71.5226 107.379 79.1544 124.049 77.6415C140.513 76.1474 155.148 66.0416 160.522 52.4559C161.924 48.9124 162.358 47.4434 164.672 38.409C166.853 29.8907 169.001 25.2179 173.278 19.6853C178.901 12.4102 187.465 6.71868 197.062 3.87785C200.01 3.0053 204.533 2.23206 207.673 2.06374C208.658 2.01104 208.822 1.94373 209.048 1.49857C209.227 1.14813 209.231 0.864321 209.06 0.571586C208.735 0.0124603 208.636 -0.0230883 207.519 0.0167386ZM83.9869 30.241C86.5108 32.5165 87.8421 35.9206 87.5808 39.4311C87.2333 44.1012 84.7463 48.0167 80.0541 51.2803C78.5113 52.3535 76.7476 53.3106 76.5215 53.1977C76.4298 53.1519 75.8893 52.4271 75.3203 51.5868C69.6968 43.2823 68.4427 36.2632 71.7788 31.7668C73.7493 29.1107 76.7108 27.7128 79.5816 28.0836C80.812 28.2424 82.9098 29.2698 83.9869 30.241Z" fill="#BFB99B" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default ProjectDetailsCard;
